// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qe_a bhb_rq bhb_kr bhb_ks","PostDetailRight__brandDaysPosts":"qe_b bhb_rq bhb_kr bhb_ks"};